export const CLASS_NAMES = {
  button:
    'flex flex-row-reverse md:flex-row justify-center md:justify-between py-3 md:py-5 px-6 rounded-full w-full md:w-68 lg:w-72',
  text: 'text-16-20-em',
  icon: 'my-auto mr-3 md:ml-3 md:mr-0',
};
